export enum SEARCH_ENGINES {
	BLOOMREACH = 'BLOOMREACH',
	FUSION = 'FUSION',
	SOLR = 'SOLR'
}
